import { BUILD_DATE } from "src/config/env";
import { useTranslation } from "src/i18n";

export function Footer() {
    const { t, language } = useTranslation('common');
    return (
        <footer>
            <div className="eac-footer-upper">
                <div className="eac-footer-links">
                    <a href={`https://www.aia.com.hk/${language}/terms-of-use.html`} target="_blank" rel="noreferrer">{t('footer.link.terms')}</a>
                    <i>|</i>
                    <a href={`https://www.aia.com.hk/${language}/privacy-statement-main.html`} target="_blank" rel="noreferrer">{t('footer.link.privacy')}</a>
                </div>
                <div className="eac-footer-updated-time">{t('footer.lastUpdated', { lastUpdated: BUILD_DATE })}</div>
            </div>
            <p>{t('footer.copyright')}</p>
        </footer>
    );
}
